// Componente Loader reutilizável

import React from 'react';

export default function Loader({ size = 'md', text = 'Carregando...' }) {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className={`${sizes[size]} border-4 border-gray-700 border-t-purple-500 rounded-full animate-spin`}></div>
      <p className="text-gray-300">{text}</p>
    </div>
  );
}
